import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "primary-container mt-4" }
const _hoisted_2 = { class: "shadow-lg p-6 bg-white rounded-2xl mx-auto" }
const _hoisted_3 = { class: "text-dark-grey font-medium text-2xl mb-6" }
const _hoisted_4 = { class: "text-sm mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "w-full mt-4 flex gap-x-4" }
const _hoisted_7 = {
  key: 0,
  class: "w-full mt-4 flex gap-x-4"
}
const _hoisted_8 = { class: "w-full mt-4 flex justify-end" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "relative px-4 pt-5 pb-4" }
const _hoisted_11 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_12 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = { class: "text-sm text-gray-500" }
const _hoisted_15 = { class: "mt-5 sm:mt-6 sm:flex sm:flex-row-reverse" }
const _hoisted_16 = { class: "relative px-4 pt-5 pb-4" }
const _hoisted_17 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_18 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_19 = { class: "mt-2" }
const _hoisted_20 = { class: "text-sm text-gray-500" }

import { ref, onMounted, watch } from "vue";
import { useSchoolGroupStore } from "@/stores/schoolGroupsStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useDataStore } from "@/stores/dataStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'ArchiveSchoolComponent',
  props: {
  actionType: {
    type: String,
    default: () => "Archive",
  },
},
  setup(__props) {

const props = __props;



const schoolGroupStore = useSchoolGroupStore();
const schoolStore = useSchoolStore();
const dataStore = useDataStore();

const selectedSchoolGroupId = ref<string | null>(null);
const selectedSchoolId = ref<string | null>(null);
const schoolGroupOptions = ref<{ label: string; value: string }[]>([]);
const schoolOptions = ref<{ label: string; value: string }[]>([]);
const showConfirmationModal = ref(false);
const showResultModal = ref(false);
const resultTitle = ref("");
const resultMessage = ref("");

onMounted(async () => {
    await schoolGroupStore.fetchSchoolGroups();
    schoolGroupOptions.value = schoolGroupStore.schoolGroups
        .map((group) => ({
            label: group.name,
            value: group._id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
});

watch(selectedSchoolGroupId, async (newVal) => {
  if (newVal) {
    const selectedGroup = schoolGroupStore.schoolGroups.find(group => group._id === newVal);
    if (selectedGroup) {
      const filteredSchools = selectedGroup.schools
        .filter((school : any) => props.actionType.toLowerCase() === "unarchive" ? school.status === 'disabled' : school.status === 'active')
        .map((school) => ({
          label: school.name,
          value: school._id,
        }));

      schoolOptions.value = filteredSchools.length > 0 ? filteredSchools : [{
        label: `No ${props.actionType}d Schools Found.`,
        value: '',
      }];
    }
  } else {
    schoolOptions.value = [];
  }
});

const confirmAction = async () => {
    if (selectedSchoolId.value) {
        try {
            if (props.actionType.toLowerCase() === "archive") {
                await schoolStore.archiveOrUnarchiveSchool(selectedSchoolId.value, props.actionType.toLowerCase() as "archive" | "unarchive");
                resultTitle.value = "Success";
                resultMessage.value = "School archived successfully.";
            } else if (props.actionType.toLowerCase() === "unarchive") {
                await schoolStore.archiveOrUnarchiveSchool(selectedSchoolId.value, props.actionType.toLowerCase() as "archive" | "unarchive");
                resultTitle.value = "Success";
                resultMessage.value = "School unarchived successfully.";
            }
            dataStore.fetchNewData();
            showConfirmationModal.value = false;
            showResultModal.value = true;
        } catch (error) {
            console.error(`Error submitting ${props.actionType.toLowerCase()} request:`, error);
            resultTitle.value = "Failure";
            resultMessage.value = `Failed to ${props.actionType.toLowerCase()} school.`;
            showConfirmationModal.value = false;
            showResultModal.value = true;
        }
    }
};

const closeResultModal = () => {
    showResultModal.value = false;
    selectedSchoolGroupId.value = null;
    selectedSchoolId.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(props.actionType) + " School ", 1),
      _createElementVNode("p", _hoisted_4, " This process will " + _toDisplayString(props.actionType.toLowerCase()) + " the selected school, champions and all learners within the school. ", 1),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FormKit, {
          type: "select",
          label: "School Groups",
          placeholder: "Select a School Group",
          name: "schoolGroup",
          modelValue: selectedSchoolGroupId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSchoolGroupId).value = $event)),
          "outer-class": "primary-select",
          options: schoolGroupOptions.value,
          classes: {
                        outer: 'w-1/2',
                    }
        }, null, 8, ["modelValue", "options"])
      ]),
      (selectedSchoolGroupId.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_FormKit, {
              type: "select",
              label: "Schools",
              placeholder: "Select a School",
              name: "school",
              modelValue: selectedSchoolId.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSchoolId).value = $event)),
              "outer-class": "primary-select",
              options: schoolOptions.value,
              classes: {
                        outer: 'w-1/2',
                    }
            }, null, 8, ["modelValue", "options"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showConfirmationModal.value = true)),
          disabled: !selectedSchoolId.value,
          class: "bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        }, _toDisplayString(props.actionType) + " School ", 9, _hoisted_9)
      ])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: showConfirmationModal.value,
      onLocalModalOpen: _cache[4] || (_cache[4] = ($event: any) => (showConfirmationModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, " Confirm " + _toDisplayString(props.actionType), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, " Are you sure you want to " + _toDisplayString(props.actionType.toLowerCase()) + " this school? ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm",
                onClick: confirmAction
              }, " Confirm "),
              _createElementVNode("button", {
                type: "button",
                class: "mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmationModal.value = false))
              }, " Cancel ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: showResultModal.value,
      onLocalModalOpen: _cache[5] || (_cache[5] = ($event: any) => (showResultModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h3", _hoisted_18, _toDisplayString(resultTitle.value), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("p", _hoisted_20, _toDisplayString(resultMessage.value), 1)
              ])
            ])
          ]),
          _createElementVNode("div", { class: "mt-5 sm:mt-6 sm:flex sm:flex-row-reverse" }, [
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm",
              onClick: closeResultModal
            }, " OK ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})